import dashboard from './es/dashboard.json';
import translation from './es/translation.json';
import requests from './es/requests.json';
import login from './es/login.json';
import menu from './es/menu.json';
import finance from './es/finance.json';
import shipment from './es/shipment.json';
import tools from './es/tools.json';
import transport from './es/transport.json'
import report from './es/report.json';
import account from './es/account.json'
import admin from './es/admin.json';
import source_lang from './es/source_lang.json';
import purchase_order from './es/purchase_order.json';
import purchase_order_detail from './es/purchase_order_detail.json';
import associationEntities from './es/assiociationEntities.json';
import supplier_management from './es/supplier_management.json';
import public_shipment from './es/public.json';


let items = {
    ...dashboard, ...translation, ...requests,
    ...report, ...account, ...admin,
    ...login, ...menu, ...finance, ...shipment, ...tools, ...transport, ...source_lang,
    ...purchase_order, ...purchase_order_detail, ...associationEntities,
    ...supplier_management, ...public_shipment
}

export default items;